// extracted by mini-css-extract-plugin
module.exports = {"CL_container":"CitiesList-module__CL_container","CL_list":"CitiesList-module__CL_list"};